import type { MouseEvent } from 'react';
import type { AskReport } from '../core/types';

export interface ReportView { view: 'standards' | 'topics' | 'teaching'; standardFilter: string | null }
export interface ReportHistory {
  owner: string;
  report: AskReport;
  view?: ReportView;
  scrollY?: number;
  focusId?: string;
  fromReport?: boolean;
}
const HISTORY_KEY = 'oneStepAheadReport';

// Browser-entry state keeps this report through Back/Forward and refresh. It is
// never sent to the server or listed as a saved report. Never store topic bodies
// here: those must be fetched fresh to recheck publication and image URLs.
export function readReportHistory(owner: string): ReportHistory | null {
  const value = window.history.state?.[HISTORY_KEY] as ReportHistory | undefined;
  return value?.owner === owner && value.report?.status === 'complete' ? value : null;
}
export function writeReportHistory(value: ReportHistory | null, url?: string, push = false) {
  const state = { ...window.history.state, [HISTORY_KEY]: value };
  if (push) window.history.pushState(state, '', url);
  else window.history.replaceState(state, '', url);
}
export function currentTopicId(): string | null {
  const match = /^\/topics\/([^/]+)\/?$/.exec(window.location.pathname);
  try { return match ? decodeURIComponent(match[1]!) : null; } catch { return null; }
}
export const topicHref = (id: string) => `/topics/${encodeURIComponent(id)}`;
export const topicLinkId = (id: string) => `read-topic-${id}`;
export function isPlainClick(event: MouseEvent<HTMLAnchorElement>) {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !event.defaultPrevented;
}
